const initialState = {
  agents: [],
  agentFilter: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ADMIN_AGENTS":
      return {
        ...state,
        agents: action.payload,
      };
    case "SET_AGENT_FILTER":
      return {
        ...state,
        agentFilter: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
